// extracted by mini-css-extract-plugin
module.exports = {"root":"root_2NSf2","loader":"loader_22kSL"};